/**
 * NotificationListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  Text,
  HtmlContent,
  ModalLayout,
  ExpandableContainer,
} from 'components';
import { Button, Input, Radio, Spin, Table, Select } from 'antd';
import Formatter from 'utils/Formatter';
import dayjs from 'dayjs';
import { render } from '@testing-library/react';
import moment from 'moment';

const TYPE_TEXT = {
  notification: '푸시알림',
  sms: '문자',
  email: '이메일',
  alim: '알림톡',
};

const DATE = [
  {
    label: '오늘',
    value: 1,
  },
  {
    label: '7일',
    value: 7,
  },
  {
    label: '1개월',
    value: 30,
  },
  {
    label: '3개월',
    value: 90,
  },
  {
    label: '6개월',
    value: 180,
  },
  {
    label: '1년',
    value: 365,
  },
];

/**----------------------------------------
 * [Component] NotificationListPresenter
 * ----------------------------------------
 */
const NotificationListPresenter = ({
  histories,
  onChange,
  inputValue,
  setInputValue,
  type,
  period,
  setSelectPeriod,
  isLoading,
  setIsLoading,
}) => {
  // console.log('history', history);
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */

  // 선택된 필터
  const [detail, setDetail] = React.useState(null);
  // 전송내역 필터 목록
  const [historyList, setHistoryList] = React.useState(histories);
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const FORM = {
    notification: [
      {
        label: '전송결과',
        form: [
          {
            input: (
              <Radio.Group
                value={inputValue['RESULT']}
                options={[
                  { label: '전체', value: 'ALL' },
                  { label: '성공', value: 200 },
                  { label: '실패', value: 500 },
                ]}
                onChange={(e) => onChange('RESULT', e.target.value)}
              />
            ),
          },
        ],
      },
      {
        label: '검색어',
        form: [
          {
            input: (
              <Select
                size="large"
                value={inputValue['KEYWORD_TYPE']}
                options={[{ label: '수신자', value: '수신자' }]}
                style={{ ...styles.form.input.large }}
                onSelect={(e) => onChange('KEYWORD_TYPE', e)}
              />
            ),
          },
          {
            input: (
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large }}
                onChange={(e) => onChange('KEYWORD', e.target.value)}
              />
            ),
          },
        ],
      },
    ],
    email: [
      {
        label: '전송결과',
        form: [
          {
            input: (
              <Radio.Group
                value={inputValue['RESULT']}
                options={[
                  { label: '전체', value: 'ALL' },
                  { label: '성공', value: 200 },
                  { label: '실패', value: 500 },
                ]}
                onChange={(e) => onChange('RESULT', e.target.value)}
              />
            ),
          },
        ],
      },
      {
        label: '검색어',
        form: [
          {
            input: (
              <Select
                size="large"
                value={inputValue['KEYWORD_TYPE']}
                options={[
                  { label: '이메일', value: '이메일' },
                  { label: '수신자', value: '수신자' },
                  { label: '플랫폼', value: '플랫폼' },
                ]}
                style={{ ...styles.form.input.large }}
                onSelect={(e) => onChange('KEYWORD_TYPE', e)}
              />
            ),
          },
          {
            input: (
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large }}
                onChange={(e) => onChange('KEYWORD', e.target.value)}
              />
            ),
          },
        ],
      },
    ],
    sms: [
      {
        label: '전송구분',
        required: true,
        form: [
          {
            input: (
              <Radio.Group
                value={inputValue['MEDIA']}
                options={[
                  { label: '전체', value: 'ALL' },
                  { label: 'SMS', value: 'SMS' },
                  { label: 'LMS', value: 'LMS' },
                  { label: 'MMS', value: 'MMS' },
                  { label: '알림톡', value: 'KAT' },
                ]}
                onChange={(e) => onChange('MEDIA', e.target.value)}
              />
            ),
          },
        ],
      },
      {
        label: '전송결과',
        form: [
          {
            input: (
              <Radio.Group
                value={inputValue['RESULT']}
                options={[
                  { label: '전체', value: 'ALL' },
                  { label: '성공', value: '성공' },
                  { label: '실패', value: '실패' },
                ]}
                onChange={(e) => onChange('RESULT', e.target.value)}
              />
            ),
          },
        ],
      },
      {
        label: '검색어',
        form: [
          {
            input: (
              <Select
                size="large"
                value={inputValue['KEYWORD_TYPE']}
                options={[
                  { label: '수신번호', value: '수신번호' },
                  { label: '수신자', value: '수신자' },
                  { label: '통신사', value: '통신사' },
                ]}
                style={{ ...styles.form.input.large }}
                onSelect={(e) => onChange('KEYWORD_TYPE', e)}
              />
            ),
          },
          {
            input: (
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large }}
                onChange={(e) => onChange('KEYWORD', e.target.value)}
              />
            ),
          },
        ],
      },
    ],
  };

  const col = {
    notification: [
      {
        key: 'key',
        title: '전송번호',
        dataIndex: 'key',
        width: 110,
        align: 'center',
      },
      {
        key: 'title',
        title: '제목',
        dataIndex: 'title',
        width: 330,
        align: 'center',
      },
      {
        key: 'body',
        title: '내용',
        dataIndex: 'body',
        width: 550,
        align: 'center',
      },
      {
        key: 'total_count',
        title: '총 전송 건수',
        dataIndex: 'total_count',
        width: 135,
        align: 'center',
        value: (v) => `${v}건`,
      },
      {
        key: 'success_count',
        title: '성공 건수',
        dataIndex: 'success_count',
        width: 150,
        align: 'center',
        render: (text, record) => (
          <div>
            <Text size={14} color={'#69B1FF'} style={{ cursor: 'pointer' }}>
              {text}건{' '}
              <Button onClick={() => setDetail(record.success)} size="small">
                상세내역
              </Button>
            </Text>
          </div>
        ),
      },
      {
        key: 'failure_count',
        title: '실패 건수',
        dataIndex: 'failure_count',
        width: 150,
        align: 'center',
        render: (text, record) => (
          <Text
            size={14}
            color={'#69B1FF'}
            style={{ cursor: 'pointer' }}
            onClick={() => setDetail(record.failure)}
          >
            {text}건{' '}
            <Button onClick={() => setDetail(record.failure)} size="small">
              상세내역
            </Button>
          </Text>
        ),
      },
      {
        key: 'send_date',
        title: '전송 시간',
        dataIndex: 'send_date',
        width: 180,
        align: 'center',
        render: (value) => moment(value).format('YYYY-MM-DD(HH:mm:ss)'),
      },
    ],
    email: [
      {
        key: 'key',
        title: '전송번호',
        dataIndex: 'key',
        width: 110,
        align: 'center',
      },
      {
        key: 'subject',
        title: '제목',
        dataIndex: 'subject',
        width: 330,
        align: 'center',
      },
      {
        key: 'html',
        title: '내용',
        dataIndex: 'html',
        align: 'center',
        width: 550,
        render: (text) => (
          <div style={{ maxHeight: 150, overflowY: 'scroll' }}>
            <HtmlContent content={text} />
          </div>
        ),
      },
      {
        key: 'total_count',
        title: '총 전송 건수',
        dataIndex: 'total_count',
        width: 165,
        align: 'center',
      },
      {
        key: 'success_count',
        title: '성공 건수',
        dataIndex: 'success_count',
        width: 165,
        align: 'center',
        render: (text, record) => (
          <div>
            <Text size={14} color={'#69B1FF'} style={{ cursor: 'pointer' }}>
              {text}건{' '}
              <Button onClick={() => setDetail(record.success)} size="small">
                상세내역
              </Button>
            </Text>
          </div>
        ),
      },
      {
        key: 'failure_count',
        title: '실패 건수',
        dataIndex: 'failure_count',
        width: 165,
        align: 'center',
        render: (text, record) => (
          <div>
            <Text size={14} color={'#69B1FF'} style={{ cursor: 'pointer' }}>
              {text}건{' '}
              <Button onClick={() => setDetail(record.failure)} size="small">
                상세내역
              </Button>
            </Text>
          </div>
        ),
      },
      {
        key: 'send_date',
        title: '전송 시간',
        dataIndex: 'send_date',
        width: 185,
        align: 'center',
      },
    ],
    sms: [
      {
        key: 'key',
        title: '전송번호',
        dataIndex: 'key',
        width: 110,
        align: 'center',
      },
      {
        key: 'name',
        title: '수신자',
        dataIndex: 'name',
        width: 210,
        align: 'center',
      },
      {
        key: 'phone',
        title: '수신번호',
        dataIndex: 'phone',
        width: 250,
        align: 'center',
        render: (text) => Formatter.hyphen(text),
      },
      {
        key: 'type',
        title: '메시지 유형',
        dataIndex: 'type',
        width: 170,
        align: 'center',
      },
      {
        key: 'agency',
        title: '통신사',
        dataIndex: 'agency',
        width: 150,
        align: 'center',
      },
      {
        key: 'result',
        title: '전송결과',
        dataIndex: 'result',
        width: 180,
        align: 'center',
      },

      {
        key: 'send_date',
        title: '전송 시간',
        dataIndex: 'send_date',
      },
    ],
  };

  const detailCol = {
    notification: [
      {
        key: 'user_id',
        title: '회원번호',
        dataIndex: 'user_id',
        width: 110,
        align: 'center',
      },
      {
        key: 'user_name',
        title: '수신자',
        dataIndex: 'user_name',
        width: 110,
        align: 'center',
      },
      {
        key: 'message',
        title: '성공여부',
        dataIndex: 'message',
        width: 180,
        align: 'center',
        render: (text) => (text === 'success' ? '성공' : '실패'),
      },
    ],
    email: [
      {
        key: 'user_id',
        title: '회원번호',
        dataIndex: 'user_id',
      },
      {
        key: 'user_name',
        title: '수신자',
        dataIndex: 'user_name',
      },
      {
        key: 'email',
        title: '이메일',
        dataIndex: 'email',
      },
      {
        key: 'message',
        title: '성공여부',
        dataIndex: 'message',
        render: (text) => (text === 'success' ? '성공' : '실패'),
      },
    ],
  };

  const handleSearchList = (t) => {
    setIsLoading(true);

    let arr = [];
    if (t === 'reset') {
      arr = histories;
      const inputValue = {};
      setInputValue(inputValue);
    }

    if (t === 'search') {
      const { MEDIA, RESULT, KEYWORD_TYPE, KEYWORD } = inputValue;
      switch (type) {
        case 'notification':
          arr = histories
            .map((_item) => {
              let {
                success,
                failure,
                success_count,
                failure_count,
                total_count,
              } = _item;

              if (RESULT === 'ALL') {
                success = _item?.success ?? [];
                failure = _item?.failure ?? [];
              } else if (RESULT === 200) {
                success = _item?.success ?? [];
                failure = [];
              } else {
                success = [];
                failure = _item?.failure ?? [];
              }
              if (KEYWORD !== '' && KEYWORD_TYPE === '수신자') {
                success = success?.filter((_item) =>
                  _item?.user_name?.includes(KEYWORD),
                );
                failure = failure?.filter((_item) =>
                  _item?.user_name?.includes(KEYWORD),
                );
              }
              success_count = success?.length ?? 0;
              failure_count = failure?.length ?? 0;
              total_count = success_count + failure_count;
              return {
                ..._item,
                success,
                failure,
                success_count,
                failure_count,
                total_count,
              };
            })
            .filter(
              (_item) => _item.success_count > 0 || _item.failure_count > 0,
            );

          break;
        case 'sms':
          arr = histories.filter((_item) => {
            const isMedia = MEDIA === 'ALL' || _item?.type === MEDIA;
            const isResult = RESULT === 'ALL' || _item?.result === RESULT;
            const isKeyWord =
              KEYWORD === ''
                ? true
                : KEYWORD_TYPE === '수신자'
                  ? _item?.name?.includes(KEYWORD)
                  : KEYWORD_TYPE === '수신번호'
                    ? _item?.phone?.includes(KEYWORD?.replace(/-/g, ''))
                    : _item?.agency === KEYWORD;
            if (isMedia && isResult && isKeyWord) return true;
          });
          break;
        //
        case 'email':
          arr = histories
            .map((_item) => {
              let {
                success,
                failure,
                success_count,
                failure_count,
                total_count,
              } = _item;

              if (RESULT === 'ALL') {
                success = _item?.success ?? [];
                failure = _item?.failure ?? [];
              } else if (RESULT === 200) {
                success = _item?.success ?? [];
                failure = [];
              } else {
                success = [];
                failure = _item?.failure ?? [];
              }
              if (KEYWORD !== '') {
                if (KEYWORD_TYPE === '이메일') {
                  success = success?.filter((_item) =>
                    _item?.email?.includes(KEYWORD),
                  );
                  failure = failure?.filter((_item) =>
                    _item?.email?.includes(KEYWORD),
                  );
                }
                if (KEYWORD_TYPE === '수신자') {
                  success = success?.filter((_item) =>
                    _item?.user_name?.includes(KEYWORD),
                  );
                  failure = failure?.filter((_item) =>
                    _item?.user_name?.includes(KEYWORD),
                  );
                }
                if (KEYWORD_TYPE === '플랫폼') {
                  success = success?.filter((_item) =>
                    _item?.email
                      ?.split('@')[1]
                      ?.includes(KEYWORD.toLowerCase()),
                  );
                  failure = failure?.filter((_item) =>
                    _item?.email
                      ?.split('@')[1]
                      ?.includes(KEYWORD.toLowerCase()),
                  );
                }
              }
              success_count = success?.length ?? 0;
              failure_count = failure?.length ?? 0;
              total_count = success_count + failure_count;
              return {
                ..._item,
                success,
                failure,
                success_count,
                failure_count,
                total_count,
              };
            })
            .filter(
              (_item) => _item?.success_count > 0 || _item?.failure_count > 0,
            );
          break;
        default:
          break;
      }
    }

    setTimeout(() => {
      setIsLoading(false);
      setHistoryList(arr);
    }, 1000);
  };

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  const columnsAndForms = React.useMemo(() => {
    let columns = [];
    let form = [];
    let detailColumns = [];
    // console.log(col);
    switch (type) {
      case 'notification':
        columns = col[type];
        form = FORM[type];
        detailColumns = detailCol[type];
        break;
      case 'email':
        columns = col[type];
        form = FORM[type];
        detailColumns = detailCol[type];
        break;
      case 'sms':
        columns = col[type];
        form = FORM[type];
        break;
      default:
        break;
    }
    return { columns, form, detailColumns };
  }, [type, inputValue, historyList]);

  /**
   * 리스트 객체 초기화
   * --
   */
  React.useEffect(() => {
    setHistoryList(histories);
  }, [histories]);

  /* ===== RENDER ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
          <Row>
            <Col x={24}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 20,
                }}
              >
                <Title style={{ ...styles.title, marginBottom: 0 }}>
                  {TYPE_TEXT[type]} 전송내역
                </Title>

                <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
                  <Radio.Group
                    buttonStyle="solid"
                    options={DATE}
                    optionType="button"
                    value={period}
                    onChange={(e) => setSelectPeriod(e.target.value)}
                  />

                  <Text size={18} weight={700}>
                    검색기간:{' '}
                    {dayjs()
                      .subtract(period, 'day')
                      .startOf()
                      .format('YYYY.MM.DD')}{' '}
                    ~ {dayjs().endOf().format('YYYY.MM.DD')}
                  </Text>
                </div>
              </div>

              {/* 검색필터 */}
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor={'none'}
                style={{ marginBottom: 40 }}
              >
                <ExpandableContainer borderRadius={4} padding={20}>
                  {columnsAndForms?.form?.map((_item, _index) => (
                    <div
                      key={`form_${_index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px 0px',
                      }}
                    >
                      <div
                        style={{ width: 120, fontSize: 13, fontWeight: 400 }}
                      >
                        <label>{_item.label}</label>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {_item.form.map((_subitem, _subkey) => (
                          <React.Fragment key={`input_${_subkey}`}>
                            {_subitem.input}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  ))}
                </ExpandableContainer>

                {/* 검색/초기화 버튼 */}
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    marginTop: 48,
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    style={{
                      ...styles.button,
                      background: 'var(--primary-color)',
                    }}
                    onClick={() => handleSearchList('search')}
                  >
                    검색
                  </Button>
                  <Button
                    size="large"
                    style={{ ...styles.button }}
                    onClick={() => handleSearchList('reset')}
                  >
                    초기화
                  </Button>
                </div>
                {/* 검색/초기화 버튼 끝 */}
              </Content>

              {/* 검색 결과 */}
              <Content maxWidth={'100%'} borderRadius={4} padding={20}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 20,
                    justifyContent: 'space-between',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <h4
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        marginBottom: 12,
                      }}
                    >
                      검색 결과 총 <span>{historyList?.length}</span>건
                    </h4>
                  </div>
                </div>
                <Table
                  scroll={{ x: 900, y: 500 }}
                  dataSource={historyList}
                  columns={columnsAndForms?.columns}
                />
              </Content>
            </Col>
          </Row>

          {/* <Row>
            <Col x={24}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 20,
                }}
              >
                <Title style={{ ...styles.title, marginBottom: 0 }}>
                  {TYPE_TEXT[type]} 전송내역
                </Title>

                <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
                  <Radio.Group
                    buttonStyle="solid"
                    options={DATE}
                    optionType="button"
                    value={period}
                    onChange={(e) => setSelectPeriod(e.target.value)}
                  />

                  <Text size={18} weight={700}>
                    검색기간:{' '}
                    {dayjs()
                      .subtract(period, 'day')
                      .startOf()
                      .format('YYYY.MM.DD')}{' '}
                    ~ {dayjs().endOf().format('YYYY.MM.DD')}
                  </Text>
                </div>
              </div>
              검색결과
              <Content maxWidth={'100%'} borderRadius={4} padding={20}>
                <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
                  검색 결과 총 <span>{data.length}</span>건
                </h4>

                <Table columns={columns} dataSource={data} />
              </Content>
              검색결과 끝
            </Col>
          </Row> */}
        </Content>
      </Spin>

      <ModalLayout
        type="drawer"
        open={!!detail}
        onCancel={() => setDetail(null)}
        title={'상세정보'}
        // closable
        width={'50%'}
      >
        <Content maxWidth={'100%'} padding={0}>
          {detail ? (
            <Table
              scroll={{ x: 800 }}
              dataSource={detail}
              columns={columnsAndForms?.detailColumns}
            ></Table>
          ) : null}
        </Content>
      </ModalLayout>
    </React.Fragment>
  );
};

export default NotificationListPresenter;
